var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInst(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 25 24",
    width: 25,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#838fae"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.5696 15c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3.00002 1.3431-3.00002 3 1.34312 3 3.00002 3z"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m7.56958 2c-2.76142 0-5 2.23858-5 5v10c0 2.7614 2.23858 5 5 5h10.00002c2.7614 0 5-2.2386 5-5v-10c0-2.76142-2.2386-5-5-5zm5.00002 15c2.7614 0 5-2.2386 5-5 0-2.76142-2.2386-5-5-5-2.76144 0-5.00002 2.23858-5.00002 5 0 2.7614 2.23858 5 5.00002 5zm7-11c0 .55228-.4477 1-1 1s-1-.44772-1-1 .4477-1 1-1 1 .44772 1 1z",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInst);
export default __webpack_public_path__ + "static/media/inst.bae4a90f0a0249fd229ef9dc2580f32a.svg";
export { ForwardRef as ReactComponent };